import React from 'react';

import { AccountCircle } from '@mui/icons-material';
import {
  FormControl,
  InputAdornment,
  MenuItem,
  NativeSelect,
  TextField,
} from '@mui/material';
import { GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid-pro';
import { BrowserView, MobileView } from 'react-device-detect';

import { ProvinceLite } from '../../../@types/State';

interface Props {
  provinces: ProvinceLite[] | undefined;
  province: ProvinceLite | undefined;
  handleProvinceChange: (event: any) => void;
  opTypes: string[] | undefined;
  opType: string;
  handleOpTypeChange: (event: any) => void;
}

const OpsToolBar: React.FC<Props> = ({
  provinces,
  province,
  handleProvinceChange,
  opTypes,
  opType,
  handleOpTypeChange,
}) => {
  return (
    <GridToolbarContainer sx={{ marginY: 1 }}>
      <GridToolbarExport />
      <BrowserView>
        {provinces && (
          <TextField
            id='province-select'
            select
            value={province ? province.id : -1}
            size='small'
            sx={{ minWidth: '180px', marginLeft: 1 }}
            onChange={handleProvinceChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <AccountCircle />
                </InputAdornment>
              ),
            }}
          >
            <MenuItem value={-1}>All Provinces</MenuItem>
            {provinces?.map((p, i) => (
              <MenuItem key={i} value={p.id}>
                {p.name}
              </MenuItem>
            ))}
          </TextField>
        )}
        {opTypes && (
          <TextField
            id='province-select'
            select
            value={opType}
            size='small'
            sx={{ minWidth: '180px', marginLeft: 1 }}
            onChange={handleOpTypeChange}
          >
            <MenuItem value={''}>All Ops</MenuItem>
            {opTypes?.map((p) => (
              <MenuItem key={p} value={p}>
                {p}
              </MenuItem>
            ))}
          </TextField>
        )}
      </BrowserView>
      <MobileView>
        {provinces && (
          <FormControl size='small' variant='outlined'>
            <NativeSelect
              id='native-province-select'
              defaultValue={province ? province.id : -1}
              sx={{ minWidth: '180px' }}
              onChange={handleProvinceChange}
              IconComponent={AccountCircle}
              variant='outlined'
            >
              <option value={-1}>All Provinces</option>
              {provinces?.map((p, i) => (
                <option key={i} value={p.id}>
                  {p.name}
                </option>
              ))}
            </NativeSelect>
          </FormControl>
        )}
      </MobileView>
    </GridToolbarContainer>
  );
};

export default OpsToolBar;
